import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';

const AiInsights = () => {
  const insights = [
    { 
      title: "Audience Shift Detected", 
      desc: "Engagement from Mid-level managers increased by 14% this week. Consider adjusting your upcoming newsletter segmentation.", 
      icon: "TrendingUp", 
      color: "text-brand-cyan",
      bg: "bg-brand-cyan/10"
    },
    { 
      title: "Tech Stack Redundancy", 
      desc: "Your usage of Marketo and Hubspot features overlaps by 60%. Potential $12k/yr savings identified in software consolidation.", 
      icon: "AlertCircle", 
      color: "text-brand-yellow",
      bg: "bg-brand-yellow/10"
    },
    { 
      title: "Content Gap Opportunity", 
      desc: "Competitors are currently ignoring 'AI in Operational Workflows'. Rapidly deploying a whitepaper here could capture 20% more SOV.", 
      icon: "Zap", 
      color: "text-brand-red",
      bg: "bg-brand-red/10"
    }
  ];

  return (
    <div className="bg-white dark:bg-slate-900 rounded-2xl p-8 shadow-xl border border-slate-100 dark:border-slate-800">
      <div className="flex items-center justify-between mb-8">
        <div className="flex items-center gap-3">
          <div className="p-2 rounded-lg bg-brand-cyan/20">
            <SafeIcon name="Cpu" className="w-6 h-6 text-brand-cyan" />
          </div>
          <h3 className="text-2xl font-heading font-bold dark:text-white text-slate-900">AI Strategic Insights</h3>
        </div>
        <span className="text-[10px] uppercase font-bold tracking-widest text-slate-400 bg-slate-100 dark:bg-slate-800 px-3 py-1 rounded-full">Live Analysis</span>
      </div>

      <div className="space-y-6">
        {insights.map((insight, idx) => (
          <motion.div 
            key={idx}
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: idx * 0.1 }}
            className="flex gap-5 p-5 rounded-xl border border-slate-50 dark:border-slate-800/50 hover:bg-slate-50 dark:hover:bg-slate-800/50 transition-colors"
          >
            <div className={`shrink-0 w-12 h-12 rounded-full flex items-center justify-center ${insight.bg} ${insight.color}`}>
              <SafeIcon name={insight.icon} className="w-5 h-5" />
            </div>
            <div>
              <h4 className="text-lg font-bold text-slate-900 dark:text-white mb-1">{insight.title}</h4>
              <p className="text-sm text-slate-600 dark:text-slate-400 font-medium leading-relaxed">{insight.desc}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default AiInsights;